const STEPS = [
  {
    step: "01",
    icon: "ri-cup-line",
    title: "A tasting, first",
    body:
      "Come to the roastery, or we bring the beans to your bar. We taste through what is on the drums right now — on your grinder and your water where we can, because that is where it has to work.",
  },
  {
    step: "02",
    icon: "ri-seedling-line",
    title: "A house blend, recommended",
    body:
      "We suggest one coffee for you to pour every day: the one that suits your equipment, your milk and the way your regulars drink. It is a recommendation, not a rule — the last word is yours.",
  },
  {
    step: "03",
    icon: "ri-calendar-schedule-line",
    title: "A standing weekly order",
    body:
      "Once the blend is settled the order repeats every week, so nobody has to remember to place it. Change it, pause it, or add a single-origin lot for the guest bar whenever you like.",
  },
  {
    step: "04",
    icon: "ri-truck-line",
    title: "Roasted to order, shipped within 48 hours",
    body:
      "Your order is roasted after it is placed, not pulled off a shelf, and it leaves us within 48 hours of coming off the drum — still resting when it reaches you.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="w-full bg-background-100 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16 reveal">
          <span className="text-xs tracking-[0.35em] uppercase text-accent-700">How It Works</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-4 leading-tight">
            A tasting, then <em>a standing order.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {STEPS.map((s, idx) => (
            <article
              key={s.step}
              className="flex flex-col bg-background-50 rounded-lg border border-background-200/60 p-8 reveal"
              style={{ transitionDelay: `${idx * 60}ms` }}
            >
              <div className="flex items-center gap-4 mb-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <span className="text-xs tracking-[0.35em] uppercase text-foreground-500">{s.step}</span>
              </div>
              <h3 className="font-heading text-2xl text-primary-950 mb-3">{s.title}</h3>
              <p className="text-foreground-700 text-sm leading-relaxed">{s.body}</p>
            </article>
          ))}
        </div>

        {/* No price list and no minimum order, because there isn't one to print:
            what a cafe pays depends on what it pours. Say so plainly rather than
            leave a visitor hunting the page for numbers that are not on it. */}
        <div className="mt-10 bg-background-50 border border-background-200 rounded-lg p-8 reveal">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-price-tag-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </div>
            <div>
              <h3 className="font-heading text-2xl text-primary-950 mb-3">On price and volume</h3>
              <p className="text-foreground-700 leading-relaxed">
                We quote per cafe, after an enquiry. There is no price list on this page and no minimum
                order to clear, because the honest answer depends on what you pour and how much of it goes
                through the bar in a week. Tell us that below and we will come back with numbers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
